/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
	const { nodes, materials } = useGLTF("models/factory4.glb");
	materials["Material.011"].color.set(0xffbf00); // Set to black

	return (
		<group {...props} dispose={null}>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath009.geometry}
				material={materials["Material.011"]}
				position={[2.257, 0.22, 0.075]}
				rotation={[0, 0, -Math.PI / 2]}
				scale={0.139}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath010.geometry}
				material={materials["Material.011"]}
				position={[2.257, 0.22, -0.102]}
				rotation={[0, 0, -Math.PI / 2]}
				scale={0.139}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath011.geometry}
				material={materials["Material.011"]}
				position={[2.257, 0.22, -0.534]}
				rotation={[0, 0, -Math.PI / 2]}
				scale={0.139}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath012.geometry}
				material={materials["Material.011"]}
				position={[2.257, 0.22, -0.71]}
				rotation={[0, 0, -Math.PI / 2]}
				scale={0.139}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath013.geometry}
				material={materials["Material.011"]}
				position={[-1.07, 1.019, 1.602]}
				rotation={[-Math.PI / 2, Math.PI / 2, 0]}
				scale={0.072}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath014.geometry}
				material={materials["Material.011"]}
				position={[-0.871, 1.019, 1.602]}
				rotation={[-Math.PI / 2, Math.PI / 2, 0]}
				scale={0.072}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath015.geometry}
				material={materials["Material.011"]}
				position={[-0.971, 1.019, 1.602]}
				rotation={[-Math.PI / 2, Math.PI / 2, 0]}
				scale={0.072}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath016.geometry}
				material={materials["Material.011"]}
				position={[-0.544, 1.019, 1.602]}
				rotation={[-Math.PI / 2, Math.PI / 2, 0]}
				scale={0.072}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath017.geometry}
				material={materials["Material.011"]}
				position={[-0.345, 1.019, 1.602]}
				rotation={[-Math.PI / 2, Math.PI / 2, 0]}
				scale={0.072}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath018.geometry}
				material={materials["Material.011"]}
				position={[-0.445, 1.019, 1.602]}
				rotation={[-Math.PI / 2, Math.PI / 2, 0]}
				scale={0.072}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath019.geometry}
				material={materials["Material.011"]}
				position={[0.006, 1.019, 1.602]}
				rotation={[-Math.PI / 2, Math.PI / 2, 0]}
				scale={0.072}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath020.geometry}
				material={materials["Material.011"]}
				position={[0.205, 1.019, 1.602]}
				rotation={[-Math.PI / 2, Math.PI / 2, 0]}
				scale={0.072}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath021.geometry}
				material={materials["Material.011"]}
				position={[0.105, 1.019, 1.602]}
				rotation={[-Math.PI / 2, Math.PI / 2, 0]}
				scale={0.072}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath022.geometry}
				material={materials["Material.011"]}
				position={[0.543, 1.019, 1.602]}
				rotation={[-Math.PI / 2, Math.PI / 2, 0]}
				scale={0.072}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath023.geometry}
				material={materials["Material.011"]}
				position={[0.741, 1.019, 1.602]}
				rotation={[-Math.PI / 2, Math.PI / 2, 0]}
				scale={0.072}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath024.geometry}
				material={materials["Material.011"]}
				position={[0.642, 1.019, 1.602]}
				rotation={[-Math.PI / 2, Math.PI / 2, 0]}
				scale={0.072}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube102.geometry}
				material={materials["Material.011"]}
				position={[0.012, 0, -0.258]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube105.geometry}
				material={materials["Material.011"]}
				position={[1.581, 0.278, -0.315]}
				scale={[0.545, 0.326, 0.545]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Sphere.geometry}
				material={materials["Material.011"]}
				position={[1.585, 0.602, -0.315]}
				scale={0.495}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube106.geometry}
				material={materials["Material.011"]}
				position={[0.435, 0.278, -0.315]}
				scale={[0.545, 0.326, 0.545]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Sphere001.geometry}
				material={materials["Material.011"]}
				position={[0.44, 0.602, -0.315]}
				scale={0.495}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane146.geometry}
				material={materials["Material.011"]}
				position={[0.56, -0.022, -2.247]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane143.geometry}
				material={materials["Material.011"]}
				position={[0.56, -0.022, -2.247]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane016.geometry}
				material={materials["Material.011"]}
				position={[0.56, -0.022, -2.247]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube104.geometry}
				material={materials["Material.011"]}
				position={[-2.117, 0.347, -1.437]}
				scale={[0.536, 0.024, 0.536]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder045.geometry}
				material={materials["Material.011"]}
				position={[1.944, -0.029, -1.441]}
				scale={[2.642, 2.67, 2.642]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder046.geometry}
				material={materials["Material.011"]}
				position={[1.37, -0.029, -1.441]}
				scale={[2.642, 2.67, 2.642]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube107.geometry}
				material={materials["Material.011"]}
				position={[1.637, 0.205, -1.448]}
				scale={[0.662, 0.178, 0.336]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube108.geometry}
				material={materials["Material.011"]}
				position={[-0.228, 0.412, -1.522]}
				rotation={[-Math.PI, 0, -Math.PI]}
				scale={[-1.12, -0.079, -0.212]}
			/>
			<group
				position={[-0.843, 0.029, -0.333]}
				rotation={[0, 1.571, 0]}
				scale={0.608}
			>
				<mesh
					castShadow
					receiveShadow
					geometry={nodes.Plane014_1.geometry}
					material={materials["Material.013"]}
				/>
				<mesh
					castShadow
					receiveShadow
					geometry={nodes.Plane014_2.geometry}
					material={materials["Material.017"]}
				/>
			</group>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube109.geometry}
				material={materials["Material.011"]}
				position={[-0.06, 0.423, 1.478]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane015.geometry}
				material={materials["Material.011"]}
				position={[-0.062, 0.242, 0.718]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder047.geometry}
				material={materials["Material.011"]}
				position={[-0.971, 1.086, 1.769]}
				rotation={[0, -Math.PI / 2, 0]}
				scale={[0.234, 0.125, 0.234]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder048.geometry}
				material={materials["Material.011"]}
				position={[-0.437, 1.086, 1.769]}
				rotation={[0, -Math.PI / 2, 0]}
				scale={[0.234, 0.125, 0.234]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder049.geometry}
				material={materials["Material.011"]}
				position={[0.103, 1.086, 1.769]}
				rotation={[0, -Math.PI / 2, 0]}
				scale={[0.234, 0.125, 0.234]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder050.geometry}
				material={materials["Material.011"]}
				position={[0.652, 1.086, 1.769]}
				rotation={[0, -Math.PI / 2, 0]}
				scale={[0.234, 0.125, 0.234]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube110.geometry}
				material={materials["Material.011"]}
				position={[-1.333, 1.104, -2.258]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Stylised_low_poly_building.geometry}
				material={materials["Material.011"]}
				position={[-2.153, 0, -2.392]}
				scale={0.247}
			/>
		</group>
	);
}

useGLTF.preload("models/factory4.glb");
